import React, { useEffect, useState } from "react";
import { object, array, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import Organism1 from "./Organism1";
import CollectionTitleWithArrow from "../../atoms/CollectionTitleWithArrow";
import { getSlug, getCollectionName } from "../../utils/utils";

import "./threeStoriesWith1Ad.m.css";
import DfpAd from "../../dfp-ad";

const ThreeStoriesWith1Ad = ({ collection, sections, domainSlug, publisherAttributes }) => {
  const [isMobile, setIsMobile] = useState(false);
  if (!(collection && collection.items && collection.items.length)) {
    return null;
  }

  const showCollectionName = get(collection, ["associated-metadata", "show_collection_name_website"], null);
  const showTagInWebsite = get(collection, ["associated-metadata", "show_tag_in_website"], true);
  const adSlotId3 = get(collection, ["associated-metadata", "ad_slot_id3"], "default_ad_slot3");

  useEffect(() => {
    global.deviceWidth < 876 && setIsMobile(!isMobile);
  }, []);

  const navigateTo = get(collection, ["associated-metadata", "navigate_to"], "");
  const navigateToTitle = get(collection, ["associated-metadata", "navigate_to_title"], "");

  const collectionName = getCollectionName(collection, navigateToTitle);
  const collectionSlug = navigateTo ? `/${navigateTo}` : getSlug(collection, sections, domainSlug);

  return (
    <div styleName="base" data-testid="three-stories-with-1ad">
      {showCollectionName && (
        <CollectionTitleWithArrow
          collectionName={collectionName}
          collectionSlug={collectionSlug}
          headlineClassName="collection-name-arrow"
          updatedFont={true}
        />
      )}
      <div styleName="wrapper">
        <Organism1 showTagInWebsite={showTagInWebsite} collection={collection} captionStyle="default" />
        <div>
          <div styleName="ad-slot">
            <DfpAd
              adtype={publisherAttributes.lang === "en" ? "EnPalo_ROS_300x250_R2" : "News_336x280_R2"}
              slotId={adSlotId3}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

ThreeStoriesWith1Ad.propTypes = {
  collection: object,
  sections: array,
  domainSlug: string,
  publisherAttributes: object,
};

const mapStateToProps = (state) => ({
  sections: get(state, ["qt", "config", "sections"], []),
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

export default connect(mapStateToProps, null)(ThreeStoriesWith1Ad);
